<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
  error: {
    type: Object as PropType<NuxtError>,
    required: true
  }
})

const { t } = useI18n()
const isForbidden = computed(() => Number(props.error?.statusCode) === 403)

useHead({
  htmlAttrs: {
    lang: 'en'
  }
})

useSeoMeta({
  title: () => isForbidden.value ? t('errors.forbidden.title') : 'Page not found',
  description: () => isForbidden.value
    ? t('errors.forbidden.body')
    : 'We are sorry but this page could not be found.'
})

</script>

<template>
  <div>
    <AppHeader />

    <UMain>
      <UContainer>
        <UPage>
          <UCard
            v-if="isForbidden"
            data-testid="forbidden-page"
            class="max-w-lg mx-auto my-12"
          >
            <div class="text-center py-6 space-y-4">
              <UIcon
                name="i-lucide-lock"
                class="text-5xl text-error-500 mx-auto"
              />
              <h1 class="text-xl font-semibold">
                {{ t('errors.forbidden.title') }}
              </h1>
              <p class="text-sm text-neutral-500">
                {{ t('errors.forbidden.body') }}
              </p>
              <UButton
                :label="t('errors.forbidden.dashboard')"
                color="primary"
                icon="i-lucide-layout-dashboard"
                to="/app/dashboard"
                data-testid="forbidden-dashboard"
                @click="clearError"
              />
            </div>
          </UCard>
          <UError
            v-else
            :error="error"
          />
        </UPage>
      </UContainer>
    </UMain>

    <AppFooter />

    <UToaster />
  </div>
</template>
